import type { DiscoveryFilter } from "../../types/filters/common";
import { InsightPackagesFilterField } from "../../types/filters/insightPackages";

export const insightPackagesFilters: DiscoveryFilter[] = [
    {
        label: "Brand",
        field: InsightPackagesFilterField.BRAND,
        isAdditional: true,
    },
    {
        label: "Browse node",
        field: InsightPackagesFilterField.BROWSE_NODE,
        isAdditional: true,
    },
    {
        label: "Advertiser goal",
        field: InsightPackagesFilterField.OBJECTIVE,
        isAdditional: true,
    },
];

export const defaultInsightPackagesFilters = insightPackagesFilters.filter(
    (filter) =>
        [
            InsightPackagesFilterField.BRAND,
            InsightPackagesFilterField.BROWSE_NODE,
        ].includes(filter.field as InsightPackagesFilterField),
);
